<template>
  <div class="description-folder">
    <div ref="content" class="content" :class="{'open': isOpen, 'no-wrap': hasFold}">{{content}}</div>
    <div class="folder" :class="{'open': isOpen}" @click="changeState" v-if="hasFold"></div>
  </div>
</template>
<script>
const LINE_HEIGHT = 22;
export default {
  name: 'DescriptionFolder',
  props: {
    content: String
  },
  data() {
    return {
      isOpen: false,
      hasFold: false
    };
  },
  methods: {
    changeState() {
      this.isOpen = !this.isOpen;
    }
  },
  mounted() {
    this.hasFold = this.$refs.content.offsetHeight > LINE_HEIGHT;
  }
};
</script>
<style lang="less" scoped>
.description-folder {
  display: flex;
  .content {
    flex: 1;
    overflow: hidden;
    line-height: 22px;
    &.no-wrap {
      white-space: nowrap;
      text-overflow: ellipsis;
      &.open {
        word-break: break-all;
        overflow: auto;
        text-overflow: initial;
        white-space: normal;
      }
    }
  }
  .folder {
    display: inline-block;
    background-image: url(./img/description-folder/bt_close_normal.png);
    background-repeat: no-repeat;
    background-position: right center;
    cursor: pointer;
    width: 20px;
    height: 20px;
    &:hover {
      background-image: url(./img/description-folder/bt_close_hover.png);
    };
    &.open {
      background-image: url(./img/description-folder/bt_open_normal.png);
      &:hover {
        background-image: url(./img/description-folder/bt_open_hover.png);
      };
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/DescriptionFolder.vue